<template>
  <b-modal
    ref='modal'
    :title="isEdit ? 'Editar MVP' : 'Novo MVP'"
    header-bg-variant='info'
    header-text-variant='light'
    size='lg'
    hide-footer
    @hidden='reset'
  >
    <section class='modal-font-family'>
      <b-form-group label='Título'>
        <b-form-input v-model='form.title' placeholder='Título do MVP' />
      </b-form-group>

      <b-form-group label='Arquivo HTML'>
        <b-form-file
          v-model='file'
          accept='.html,text/html'
          placeholder='Selecione o arquivo .html'
          browse-text='Procurar'
        />
        <small v-if='isEdit' class='text-muted'>
          Já existe um HTML salvo. Envie um novo arquivo para substituir, ou deixe vazio para manter o atual.
        </small>
      </b-form-group>

      <b-form-checkbox v-model='form.active' switch class='mb-3'>
        Ativo (aparece no aviso para os usuários)
      </b-form-checkbox>

      <b-alert :show='!!error' variant='danger'>{{ error }}</b-alert>

      <section class='d-flex'>
        <b-button
          variant='danger'
          class='flex-fill mr-2'
          @click="$refs.modal.hide()"
        >
          Cancelar
        </b-button>

        <b-overlay
          :show='loading'
          rounded
          opacity='0.6'
          spinner-small
          spinner-variant='primary'
          class='flex-fill'
        >
          <b-button
            variant='success'
            block
            @click='submit'
          >
            {{ isEdit ? 'Salvar' : 'Cadastrar' }}
          </b-button>
        </b-overlay>
      </section>
    </section>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AddMvp',
  data() {
    return {
      isEdit: false,
      loading: false,
      error: '',
      file: null,
      form: {
        _id: null,
        title: '',
        active: true
      }
    }
  },
  methods: {
    ...mapActions('mvp', {
      handleCreateMvp: 'handleCreateMvp',
      handleUpdateMvp: 'handleUpdateMvp'
    }),
    open(mvp) {
      this.reset()
      if (mvp) {
        this.isEdit = true
        this.form = {
          _id: mvp._id,
          title: mvp.title || '',
          active: mvp.active !== undefined ? mvp.active : true
        }
      }
      this.$refs.modal.show()
    },
    reset() {
      this.isEdit = false
      this.loading = false
      this.error = ''
      this.file = null
      this.form = {
        _id: null,
        title: '',
        active: true
      }
    },
    readFileText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = () => reject(reader.error)
        reader.readAsText(file)
      })
    },
    async submit() {
      this.error = ''
      if (!this.form.title || !this.form.title.trim()) {
        this.error = 'Informe o título do MVP.'
        return
      }
      if (!this.isEdit && !this.file) {
        this.error = 'Selecione o arquivo HTML do MVP.'
        return
      }
      if (this.file && !/\.html?$/i.test(this.file.name)) {
        this.error = 'Selecione um arquivo .html'
        return
      }
      if (this.file && this.file.size > 5 * 1024 * 1024) {
        this.error = 'Arquivo muito grande (máx. 5MB).'
        return
      }
      try {
        this.loading = true

        const body = {
          title: this.form.title,
          active: this.form.active
        }

        if (this.file) {
          body.htmlContent = await this.readFileText(this.file)
        }

        let response
        if (this.isEdit) {
          response = await this.handleUpdateMvp({ id: this.form._id, body })
        } else {
          response = await this.handleCreateMvp(body)
        }

        if (response && response.data && response.data.errors) {
          this.loading = false
          this.error = response.data.errors
          return
        }

        this.loading = false
        this.$refs.modal.hide()
        this.$emit('saved')
      } catch (e) {
        this.loading = false
        this.error = 'Não foi possível salvar o MVP. Tente novamente.'
      }
    }
  }
}
</script>
